import jwt_decode from 'jwt-decode';

export  default  {

    user: {
        authenticated: false,
        access_token: ''
    },
    checkAuth() {
        console.log('check Auth');
        var jwt = localStorage.getItem('access_token');
        (jwt) ? this.user.authenticated = true : this.user.authenticated = false

    },
    getToken(){

        if (this.user.keycloak!=undefined)
        {
            return this.user.keycloak.token; }
        else
        {
            return 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJKUGlkbDMwUWxFQmxqTGVadzhxeFh6RWdJeWh0ZjFjZkhHcm1HSGxEUk9BIn0.eyJqdGkiOiIwN2UxNmVmNS1iY2JkLTRhOTgtODI0Ny1hNDM3MzY5NDg3ZjQiLCJleHAiOjE1MzU2MTY2MDYsIm5iZiI6MCwiaWF0IjoxNTM1NjE2NTQ2LCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjgwODAvYXV0aC9yZWFsbXMvbWFzdGVyIiwiYXVkIjoibXlhcHAiLCJzdWIiOiI2Yzc5MjU1Yy05YjlmLTRhMzktOTQ5YS05NmRjY2ZmOGQxNGQiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJteWFwcCIsIm5vbmNlIjoiNzgxYzhlMDctOTVkZC00YzA1LWI4M2QtZWExYjBhZmVjNzY2IiwiYXV0aF90aW1lIjoxNTM1NjE2MjAwLCJzZXNzaW9uX3N0YXRlIjoiNGE0OTljMTktYzYxMy00YjZiLWIzYWEtNTYxNzkwNzU5NGNjIiwiYWNyIjoiMCIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwOi8vbG9jYWxob3N0OjgwODEiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbImNyZWF0ZS1yZWFsbSIsIm9mZmxpbmVfYWNjZXNzIiwiYWRtaW4iLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7Im1hc3Rlci1yZWFsbSI6eyJyb2xlcyI6WyJ2aWV3LWlkZW50aXR5LXByb3ZpZGVycyIsInZpZXctcmVhbG0iLCJtYW5hZ2UtaWRlbnRpdHktcHJvdmlkZXJzIiwiaW1wZXJzb25hdGlvbiIsImNyZWF0ZS1jbGllbnQiLCJtYW5hZ2UtdXNlcnMiLCJxdWVyeS1yZWFsbXMiLCJ2aWV3LWF1dGhvcml6YXRpb24iLCJxdWVyeS1jbGllbnRzIiwicXVlcnktdXNlcnMiLCJtYW5hZ2UtZXZlbnRzIiwibWFuYWdlLXJlYWxtIiwidmlldy1ldmVudHMiLCJ2aWV3LXVzZXJzIiwidmlldy1jbGllbnRzIiwibWFuYWdlLWF1dGhvcml6YXRpb24iLCJtYW5hZ2UtY2xpZW50cyIsInF1ZXJ5LWdyb3VwcyJdfSwiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgZW1haWwgcHJvZmlsZSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwicHJvamVjdCI6WyJzb2x2ZWQtcmQiXSwicHJlZmVycmVkX3VzZXJuYW1lIjoiZHBpc2NpYSIsImdyb3VwIjpbIi9hZG1pbiIsIi9jbmFnLWd1dCJdfQ.FRql1Nl3qMsYaVRuePnU7VffQ-XQ-6p8fEonqhW5vcjq2A3yR1lOiuBBn7PRrU1q_Fb8Guq4DjmfOv9daT9LiawiYz_MHcWkopR5HuyUz2H9Ican46ehWS-rcZHApVqDqYqfZk08WEHnAoiXeNLbeU3VYxm3UaN4QMwP2aGgVg5G9Ka-pb24jN3BOcan8kMEgeimUa32THQw4p6fViuesAHKsKrk7YRqNDWMHnvNbcfckFx1yefVnUsAiBcHqaWsf4MRzjNnY1hYgqhT2XlMzlglzUGAII7QDEMIaQG2tljWBWg7UJazw80UuebFRNN0YJJYz1W1oOmIn00ETxwSQw'
        }
    },
    decoded(){
        if (this.user.keycloak!==undefined)

            return jwt_decode(this.user.keycloak.token);
        else
            return "empty"
    },
    setToken(user){
        this.user=user;
        this.user.authenticated = true;
        console.log(this.user);
    },

    // get the username information
    getUser(){

        return this.user;
    }

}


